import React from "react";
import { Navigate, Outlet } from "react-router-dom";

function ProtectedRoute() {
  const isLoggedIn = !!window.sessionStorage.getItem("token");
  
  return isLoggedIn ?<Outlet/>:<Navigate to="login"/>;
}

export default ProtectedRoute;
